import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ButtonIcon from '../../../../button';
import { ROUTE_LINK_LOCATION, Selected_Index } from '../../../../../constants/external-constants';
import { ListTabButton } from '../../../../common/list-tab/list-tab-button.component';
import ManageUserForm from '../Form/ManageUserForm';
import ManageUserCommentsComponent from './../manage-user-comments/manage-user-comments.component'
import ManageUserHistoryComponent from './../manage-user-history/manage-user-history.component'
import { hrDetailsActions } from '../../../../../store/external/manage-user/form/manage-user-form.reducer';
import { validateAccessModule } from '../../../../../utils/helpers.utils';
import { ACCESS_MODULE, MATRIX_INDICATOR } from '../../../../../utils/rbac-constants.utils';
class DetailsViewManageUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: "0",
            listTab: [
                {
                    "id": Selected_Index.i_Zero,
                    "label": "Details",
                    "hidden": false
                },
                {
                    "id": Selected_Index.i_One,
                    "label": "Line Items",
                    "hidden": true,
                    "disable": false
                },
                {
                    "id": Selected_Index.i_Two,
                    "label": "Audit",
                    "hidden": true,
                    "disable": false
                },
                {
                    "id": Selected_Index.i_Three,
                    "label": "Cost Allocation",
                    "hidden": true,
                    "disable": false
                },
                {
                    "id": Selected_Index.i_Four,
                    "label": "Comments",
                    "hidden": false,
                    "disable": true
                },
                {
                    "id": Selected_Index.i_Five,
                    "label": "History",
                    "hidden": false,
                    "disable": true
                }
            ],
        }
    }
    componentDidMount(){
        window.scrollTo(0, 0);
    }
    
    FilterIndex = (index) =>{
        this.setState({selectedIndex: index});
    }
    handlecloseForm = () => {
        const { closeFormAction, resetmanageUserHrDetailsForm, pageRedirection, resetAction } = this.props;
        if (pageRedirection) {
            this.props.history.push(`${ROUTE_LINK_LOCATION.hrManagerLink}`);
        }
        resetmanageUserHrDetailsForm();
        closeFormAction();
    }

    renderTabContent = (index) => {
        this.setState({ selectedTab: index });
    }

    activeListTab = (listTab) => {
        const { employeeId, manageUserHrDetailsForm } = this.props;

        return listTab.map(item => {
            var disabled = item.disable;
            if ((item.id == Selected_Index.i_Four || item.id == Selected_Index.i_Five) && employeeId > 0 || (manageUserHrDetailsForm && manageUserHrDetailsForm.employeeId > 0)) {
                disabled = false;
            }

            return {
                ...item,
                disable: disabled
            };
        })
    }

    render() {
        const { listTab, selectedIndex } = this.state;
        const { closeFormAction, employeeId, userId, manageUserHrDetailsForm, setEmployeeId } = this.props
        let employeeDetailsId = employeeId > 0 ? employeeId : manageUserHrDetailsForm && manageUserHrDetailsForm.employeeId > 0 ? manageUserHrDetailsForm.employeeId : employeeId;
        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.HRManagementDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.HRManagementDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.HRManagementDashboardRW])
        return (
             <div className="layout-container">
                <ButtonIcon onClick={this.handlecloseForm} iconLeft="chevron-left" iconSize="17px" customClassName="manage-invoice-back-button" labelName="Back" />
                {listTab ? <ListTabButton listData={this.activeListTab(listTab)} selectedIndex={selectedIndex} FilterIndex={this.FilterIndex} /> : null}
                <div className={`${this?.props?.isMultiContainer ? "" : "details-container"} date-picker-main-container`}>
                    {(selectedIndex === Selected_Index.i_Zero || this.props.selected) && <ManageUserForm employeeId={employeeDetailsId} userId={userId} isReadOnly={isReadOnly} isReadAndExtractOnly={isReadAndExtractOnly} isReadAndWrite={isReadAndWrite} setEmployeeId={setEmployeeId} />}
                    {selectedIndex === Selected_Index.i_Four && <ManageUserCommentsComponent employeeId={employeeDetailsId} isReadOnly={isReadOnly} isReadAndExtractOnly={isReadAndExtractOnly} isReadAndWrite={isReadAndWrite} />}
                    {selectedIndex === Selected_Index.i_Five && <ManageUserHistoryComponent employeeId={employeeDetailsId} hideCustomColumn={true} isReadOnly={isReadOnly} isReadAndExtractOnly={isReadAndExtractOnly} isReadAndWrite={isReadAndWrite} />}
                </div>
            
            </div>
        );
    }
}

export default connect(
    state => {
        const { manageUserHrDetails, translation } = state;
        const { manageUserHrDetailsForm } = state.form;

        return {
            manageUserHrDetails,
            manageUserHrDetailsForm,
            ...translation
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, hrDetailsActions),
            dispatch
        ),
    })
)(DetailsViewManageUser);